import {hitAlgolytics} from "@pg-mono/algolytics";

import {ITrackedApplication} from "../../../tracking/algolytics_hits/application_hit";
import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {ViewType} from "../../../view_type/ViewType";
import {RecommendedOfferApplicationsType} from "../../hooks/multi_lead/use_track_recommended_offers_application";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";

export const hitOfferMultileadSent = (
    recommendedOffers: RecommendedOfferApplicationsType[],
    viewType: ViewType | null,
    recommendationType: ApplicationMultiLeadRecommendationType,
    application: ITrackedApplication | null | undefined
) => {
    const payload = {
        ...getTrackedSiteData(),
        ...(viewType ? {view_type: viewType} : {}),
        offers: recommendedOffers.map(([_application, property]) => property.id),
        recommendationType,
        financing_services: application?.financing_services ?? null,
        email: application?.email ?? null,
        name: application?.name ?? null,
        phone: application?.phone ?? null
    };
    hitAlgolytics("multi_application", payload);
};
